import React from "react";
import AuthService from "./components/auth/AuthService";
import { Redirect } from "react-router-dom";

const Auth = new AuthService();

class ProtectedRoute extends React.Component {
  render() {
    const Component = this.props.component;
    const isAuthenticated = Auth.loggedIn();

    return isAuthenticated ? (
      <Component />
    ) : (
      <Redirect to={{ pathname: "/" }} />
    );
  }
}

export default ProtectedRoute;
